import { render, staticRenderFns } from "./FinancialSummaryWidget.vue?vue&type=template&id=6189fff0&scoped=true"
import script from "./FinancialSummaryWidget.vue?vue&type=script&lang=js"
export * from "./FinancialSummaryWidget.vue?vue&type=script&lang=js"
import style0 from "./FinancialSummaryWidget.vue?vue&type=style&index=0&id=6189fff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189fff0",
  null
  
)

export default component.exports